<template src="./Add.html"></template>

<script>

// import { showAlert } from "@/utils/helpers";

export default {
  created() {

  },
  computed: {
    rooms() {
      return [
        { value: 1, label: " الغرفة 1 " },
        { value: 2, label: "الغرفة 2" },

      ]
    },
    doctors(){
      return [
        {value:1 , label:"د. أحمد على "},
        {value:2 , label:"د. الهادي المختار"},
        
      ]
    },
  },
  data() {
    return {
      vm: {
        doctorId: null,
      },
      daysOfWeek:
        [
        {
            value: "Sat", label: "السبت"
          },
          {
            value: "Sun", label: "الاحد"
          },
          {
            value: "Mon", label: "الاثنين"
          },
          {
            value: "Tue", label: "الثلاثاء"
          },
          {
            value: "Wed", label: "الاربعاء"
          },
          {
            value: "Thu", label: "الخميس"
          },
          {
            value: "Fri", label: "الجمعة"
          },


        ],
      times: [
        "6:00 صباحا", "7:00 صباحا", "8:00 صباحا", "9:00 صباحا", "10:00 صباحا",
        "11:00 صباحا", "12:00 مساءاَ", "1:00 مساءاَ", "2:00 مساءاَ", "3:00 مساءاَ",
        "11:00 صباحا", "12:00 مساءاَ", "1:00 مساءاَ", "2:00 مساءاَ", "3:00 مساءاَ",
        "4:00 مساءاَ", "5:00 مساءاَ", "6:00 مساءاَ", "7:00 مساءاَ", "8:00 مساءاَ",
        "9:00 مساءاَ", "10:00 مساءاَ"
      ],
      availability: {
        Sun: { from: null, to: null, roomId: null },
        Mon: { from: null, to: null, roomId: null },
        Tue: { from: null, to: null, roomId: null },
        Wed: { from: null, to: null, roomId: null },
        Thu: { from: null, to: null, roomId: null },
        Fri: { from: null, to: null, roomId: null },
        Sat: { from: null, to: null, roomId: null },
      },
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("patients/edit", { id: this.itemId, payload: this.patient })
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    allowedDates(val) {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 2);
      const date = new Date(val);
      return date < today;
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>